import React from 'react';
import { Button } from '@bsf/force-ui';
import { ArrowRight, Check, Star, Users, Lock } from 'lucide-react';
import { __ } from '@wordpress/i18n';
import '../../Styles.css';

const SURERANK_URL = 'https://wpschema.com/surerank/?utm_source=schema-pro&utm_medium=onboarding-offer';
const SURERANK_WP_ORG_URL = 'https://wordpress.org/plugins/surerank/?utm_source=schema-pro&utm_medium=onboarding-offer';

const PINK = '#E62A5E';
const INDIGO = '#4F39F6';
const INDIGO_DARK = '#3F2EE0';

const Create = () => {
	const schemaTypeUrl = schemaSettingsData.wpsp_schema_type_url;
	const sureRankLogoUrl = schemaSettingsData.surerank_logo_url;

	const goToSchemaTypes = () => {
		window.location.href = schemaTypeUrl;
	};

	const goToSureRank = () => {
		window.open( SURERANK_URL, '_blank', 'noopener,noreferrer' );
	};

	const goToSureRankWpOrg = () => {
		window.open( SURERANK_WP_ORG_URL, '_blank', 'noopener,noreferrer' );
	};

	return (
		<div
			className="bg-background-primary border-[0.5px] border-subtle rounded-xl shadow-sm mb-6 p-10 schema-onboarding-offer"
		>
			{/* Top section: two columns */}
			<div className="flex flex-col lg:flex-row gap-2">
				{/* Left column */}
				<div className="flex-1 min-w-0 flex flex-col items-start gap-2">
					<span
						className="font-semibold uppercase tracking-wide"
						style={{ color: PINK, fontSize: '0.78rem', letterSpacing: '0.04em' }}
					>
						{__( 'All set! But before you leave\u2026', 'wp-schema-pro' )}
					</span>

					<h1
						className="text-text-primary m-0 mb-5"
						style={{
							fontSize: '1.6rem',
							lineHeight: '1.3em',
							fontWeight: 700,
							maxWidth: '32ch',
						}}
					>
						{__(
							"We've Got the Schema Side Sorted. Here's the Rest of SEO.",
							'wp-schema-pro'
						)}
					</h1>

					<p
						className="text-text-tertiary m-0 mb-6"
						style={{ fontSize: '0.9rem', lineHeight: '1.7em' }}
					>
						{__(
							'Schema Pro is still running, still supported, and still excellent at what it does. If you ever want to bring your full SEO workflow into one place, SureRank is built for that.',
							'wp-schema-pro'
						)}
					</p>

					<ul
						className="list-none m-0 mb-8"
						style={{ padding: 0, fontSize: '0.9rem', lineHeight: '1.7em' }}
					>
						<li
							className="text-text-tertiary"
							style={{ display: 'flex', alignItems: 'center', gap: '0.625rem' }}
						>
							<Check color={ PINK } size={ 18 } strokeWidth={ 2.5 } />
							{__( 'AI fixes meta tags, internal links, and SEO automatically.', 'wp-schema-pro' )}
						</li>
						<li
							className="text-text-tertiary"
							style={{ display: 'flex', alignItems: 'center', gap: '0.625rem' }}
						>
							<Check color={ PINK } size={ 18 } strokeWidth={ 2.5 } />
							{__( 'Rankings, clicks, and traffic data right inside WordPress.', 'wp-schema-pro' )}
						</li>
						<li
							className="text-text-tertiary"
							style={{ display: 'flex', alignItems: 'center', gap: '0.625rem' }}
						>
							<Check color={ PINK } size={ 18 } strokeWidth={ 2.5 } />
							{__( 'Everything Schema Pro does, plus full SEO coverage.', 'wp-schema-pro' )}
						</li>
					</ul>

				</div>

				{/* Right column: offer card + no-thanks link */}
				<div className="flex flex-col items-stretch gap-2 schema-offer-card-col" style={{ flexShrink: 0 }}>
					<div
						className="rounded-xl p-4 flex flex-col items-center text-center"
						style={{
							border: `2px solid ${ INDIGO }`,
							background:
								'linear-gradient(180deg, #F4F2FF 0%, #FFFFFF 60%, #FDF7FF 100%)',
						}}
					>
						<span
							className="inline-block rounded-full px-3 py-1 mb-4"
							style={{
								backgroundColor: INDIGO,
								color: '#FFFFFF',
								fontSize: '0.72rem',
								fontWeight: 600,
							}}
						>
							{__( 'Exclusive Offer', 'wp-schema-pro' )}
						</span>

						<span
							className="text-text-primary mb-4"
							style={{ fontSize: '0.75rem', fontWeight: 600 }}
						>
							{__( 'SureRank Pro Annual \u00b7 3 Sites', 'wp-schema-pro' )}
						</span>

						<span
							className="text-text-tertiary"
							style={{ fontSize: '0.72rem', letterSpacing: '0.08em' }}
						>
							{__( 'UPTO', 'wp-schema-pro' )}
						</span>
						<span
							className="text-text-primary"
							style={{ fontSize: '2.4rem', fontWeight: 700, lineHeight: '1.1em' }}
						>
							{__( '50% OFF', 'wp-schema-pro' )}
						</span>

						<span
							className="text-text-tertiary mt-2"
							style={{ fontSize: '0.78rem', lineHeight: '1.5em' }}
						>
							{__( 'Offer exclusive to this page', 'wp-schema-pro' )}
						</span>
						<span
							className="text-text-tertiary mb-4"
							style={{ fontSize: '0.78rem', lineHeight: '1.5em' }}
						>
							{__( 'Just for Schema Pro customers', 'wp-schema-pro' )}
						</span>

						<Button
							variant="primary"
							className="schema-remove-ring w-full"
							style={{
								backgroundColor: INDIGO,
								transition: 'background-color 0.3s ease',
								padding: '10px 20px',
								outlineColor: INDIGO,
								width: '100%',
							}}
							onMouseEnter={ ( e ) => ( e.currentTarget.style.backgroundColor = INDIGO_DARK ) }
							onMouseLeave={ ( e ) => ( e.currentTarget.style.backgroundColor = INDIGO ) }
							onClick={ goToSureRank }
						>
							<span
								style={{
									display: 'inline-flex',
									alignItems: 'center',
									justifyContent: 'center',
									gap: '0.5rem',
									width: '100%',
								}}
							>
								<img
									src={ sureRankLogoUrl }
									alt=""
									aria-hidden="true"
									style={{ width: '14px', height: '14px', display: 'block' }}
								/>
								{ __( 'Get SureRank', 'wp-schema-pro' ) }
								<ArrowRight size={ 16 } />
							</span>
						</Button>
					</div>

					<button
						type="button"
						onClick={ goToSchemaTypes }
						className="bg-transparent border-0 cursor-pointer mt-6 self-center underline"
						style={{
							color: '#4B5563',
							fontSize: '0.85rem',
							padding: 0,
						}}
					>
						{ __( 'No thanks, I will do SEO manually', 'wp-schema-pro' ) }
					</button>
				</div>
			</div>
			
			{/* Stat boxes */}
					<div className="flex flex-wrap gap-3" style={{ paddingTop: '25px', width: '88%'}}>
						<div
							className="flex items-center rounded-md px-4 py-4 flex-1"
							style={{ backgroundColor: '#FFF0F3' , gap:'0.5rem'}}
						>
							<Star color={ PINK } size={ 18 } strokeWidth={ 2 } fill={ PINK } />
							<span
								className="text-text-primary"
								style={{ fontSize: '0.78rem', lineHeight: '1.3em', fontWeight: 500 }}
							>
								{__( '4.8 Rated on WordPress.org', 'wp-schema-pro' )}
							</span>
						</div>
						<div
							className="flex items-center rounded-md px-4 py-4 flex-1"
							style={{ backgroundColor: '#FFF0F3', minWidth: '0' , gap:'0.5rem' }}
						>
							<Users color={ PINK } size={ 18 } strokeWidth={ 2 } />
							<span
								className="text-text-primary"
								style={{ fontSize: '0.78rem', lineHeight: '1.3em', fontWeight: 500 }}
							>
								{__( 'Trusted by 300K+ Active Users', 'wp-schema-pro' )}
							</span>
						</div>
						<div
							className="flex items-center rounded-md px-4 py-4 flex-1"
							style={{ backgroundColor: '#FFF0F3', minWidth: '0' , gap:'0.5rem' }}
						>
							<Lock color={ PINK } size={ 18 } strokeWidth={ 2 } />
							<span
								className="text-text-primary"
								style={{ fontSize: '0.78rem', lineHeight: '1.3em', fontWeight: 500 }}
							>
								{__( '14-Day Money Back Guarantee', 'wp-schema-pro' )}
							</span>
						</div>
					</div>


			{/* Bottom reassurance + footer CTAs */}
			<div className="flex flex-col gap-5" style={{ paddingTop: '25px'}}>
				<span
					className="text-text-primary"
					style={{ fontSize: '0.9rem', lineHeight: '1.6em' }}
				>
					<strong>{ __( "Schema Pro isn't going away.", 'wp-schema-pro' ) }</strong>{ ' ' }
					{ __(
						"It stays active and supported. SureRank is just what's next.",
						'wp-schema-pro'
					) }
				</span>

				<hr
				className="w-full border-b-0 border-x-0 border-t border-solid"
				style={{ borderColor: '#E5E7EB' }}
				/>

				<div className="flex items-center justify-end gap-5 flex-shrink-0">
					<button
						type="button"
						onClick={ goToSureRankWpOrg }
						className="bg-transparent border-0 cursor-pointer p-0"
						style={{ color: '#4B5563', fontSize: '0.9rem', fontWeight: 500 }}
					>
						{ __( 'Try SureRank for Free', 'wp-schema-pro' ) }
					</button>

					<Button
						icon={ <ArrowRight /> }
						iconPosition="right"
						variant="primary"
						className="schema-remove-ring"
						style={{
							backgroundColor: PINK,
							transition: 'background-color 0.3s ease',
							padding: '12px 20px',
							outlineColor: PINK,
						}}
						onMouseEnter={ ( e ) => ( e.currentTarget.style.backgroundColor = PINK ) }
						onMouseLeave={ ( e ) => ( e.currentTarget.style.backgroundColor = PINK ) }
						onClick={ goToSchemaTypes }
					>
						{ __( 'Continue with Schema Pro', 'wp-schema-pro' ) }
					</Button>
				</div>
			</div>
		</div>
	);
};

export default Create;
